import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import accountRules from '../../../../common/rules/accountRules';
import Checkbox from 'antd/lib/checkbox';

const formItemLayoutWithoutLabel = {
  wrapperCol: {
    xs: {
      span: 15,
      offset: 9,
    },
    sm: {
      span: 14,
      offset: 6
    },
  },
};

class AdditionalPhonesHelper extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
  };

  addPhone = () => {
    const { form } = this.props;
    const phonesKeys = form.getFieldValue('phonesKeys');
    const newPhones = [...phonesKeys, phonesKeys.length];
    form.setFieldsValue({ phonesKeys: newPhones });
    setTimeout(() => {
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].number`]: null });
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].active`]: false });
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].prefered`]: false });
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].checked`]: false });
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].notContact`]: false });
      form.setFieldsValue({ [`phoneNumbers[${phonesKeys.length}].anotherPerson`]: false });
    });
  }

  removePhone = key => {
    const { form } = this.props;
    const phonesKeys = form.getFieldValue('phonesKeys');
    const phoneNumbers = form.getFieldValue('phoneNumbers');
    phoneNumbers.filter((_, i) => key !== i)
      .forEach((phoneNumber, i) => {
        form.setFieldsValue({ [`phoneNumbers[${i}].number`]: phoneNumber.number });
        form.setFieldsValue({ [`phoneNumbers[${i}].active`]: phoneNumber.active });
        form.setFieldsValue({ [`phoneNumbers[${i}].prefered`]: phoneNumber.prefered });
        form.setFieldsValue({ [`phoneNumbers[${i}].checked`]: phoneNumber.checked });
        form.setFieldsValue({ [`phoneNumbers[${i}].notContact`]: phoneNumber.notContact });
        form.setFieldsValue({ [`phoneNumbers[${i}].anotherPerson`]: phoneNumber.anotherPerson });
    });
    form.setFieldsValue({
      phonesKeys: [...Array(phonesKeys.length - 1).keys()],
    });
  }

  render() {
    const { account, isEditable, isCallCentrum, form, t } = this.props;
    const { getFieldDecorator, getFieldValue } = form;

    // define helper for dynamic phones
    getFieldDecorator('phonesKeys', { initialValue: [...Array(account.phoneNumbers.length).keys()] });

    return (
      <React.Fragment>
        { 
          getFieldValue('phonesKeys').map(key => (
            <Form.Item {...formItemLayoutWithoutLabel} key={key}>
              {!isEditable && <span style={{ display: 'block', lineHeight: 'initial'}}>{account.phoneNumbers[key] ? account.phoneNumbers[key].number : null}</span>}
              {isEditable &&
                <Row>
                  <Col xs={11} sm={11} md={11} lg={11}>
                    {
                      getFieldDecorator(`phoneNumbers[${key}].number`, {
                        rules: accountRules.additionalTelephoneNumber,
                        initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].number : null,
                      })(<Input size="default" placeholder={t('09xx xxx xxx')}/>)
                    }
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    { (!isCallCentrum || account.phoneNumbers.length <= key) &&
                      <Icon
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        title={t('Odstrániť číslo')}
                        onClick={() => this.removePhone(key)}
                      />
                    }
                  </Col>
                </Row>
              }

              {!isEditable && <Checkbox checked={account.phoneNumbers[key] ? account.phoneNumbers[key].active : false} disabled>{t('Aktívne')}</Checkbox>}
              {isEditable && getFieldDecorator(`phoneNumbers[${key}].active`, {
                initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].active : false,
                valuePropName: 'checked',
              })(<Checkbox style={{ marginRight: 10 }}>{t('Aktívne')}</Checkbox>
              )}
                
              {!isEditable && <Checkbox checked={account.phoneNumbers[key] ? account.phoneNumbers[key].prefered : false} disabled >{t('Preferované')}</Checkbox>}
              {isEditable && getFieldDecorator(`phoneNumbers[${key}].prefered`, {
                initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].prefered : false,
                valuePropName: 'checked',
              })(<Checkbox style={{ marginRight: 10 }}>{t('Preferované')}</Checkbox>
              )}
                
              {!isEditable && <Checkbox checked={account.phoneNumbers[key] ? account.phoneNumbers[key].checked : false} disabled >{t('Overené')}</Checkbox>}
              {isEditable && getFieldDecorator(`phoneNumbers[${key}].checked`, {
                initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].checked : false,
                valuePropName: 'checked',
              })(<Checkbox style={{ marginRight: 10 }}>{t('Overené')}</Checkbox>
              )}
                
              {!isEditable && <Checkbox checked={account.phoneNumbers[key] ? account.phoneNumbers[key].notContact : false} disabled >{t('Nekontaktovať')}</Checkbox>}
              {isEditable && getFieldDecorator(`phoneNumbers[${key}].notContact`, {
                initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].notContact : false,
                valuePropName: 'checked',
              })(<Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
              )}
                
              {!isEditable && <Checkbox checked={account.phoneNumbers[key] ? account.phoneNumbers[key].anotherPerson : false} disabled >{t('Iná osoba')}</Checkbox>}
              {isEditable && getFieldDecorator(`phoneNumbers[${key}].anotherPerson`, {
                initialValue: account.phoneNumbers[key] ? account.phoneNumbers[key].anotherPerson : false,
                valuePropName: 'checked',
              })(<Checkbox>{t('Iná osoba')}</Checkbox>
              )}
            </Form.Item>
          ))
        }
        { isEditable && 
          <Form.Item {...formItemLayoutWithoutLabel}>
            <Row>
              <Col xs={11} sm={11} md={11} lg={11}>
                <Button type="dashed" size="small" onClick={this.addPhone} style={{ width: '100%' }}>
                  <Icon type="plus" /> {t('Pridať telefónne číslo')}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        }
      </React.Fragment>
    );
  }
}

export default translate()(AdditionalPhonesHelper);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/AdditionalPhonesHelper.js